import Pano from '../components/luzmo-dashboard';

interface Props {
  dashboardId: string;
  authKey: string;
  authToken: string;
  panoId: string;
  email: string;
  jwt: string;
}

export function ProtectedPage({ dashboardId, authKey, authToken, email, jwt, panoId }: Props) {

  return (
    <div className="protected-container">
      <Pano
        authKey={authKey}
        authToken={authToken}
        dashboardId={dashboardId}
        email={email}
        jwt={jwt}
        panoId={panoId}
      />
      <div id="chat-window"></div>
    </div>
  );
}
